import {
  CreateFormResponseInput,
  FormNameEnum,
  FormResponseOwnerTypeEnum,
  useCreateFormResponseMutation,
  useMutationNotifier,
  type CreateFormResponseMutation,
} from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'

export type CreateFormResponseVariables = Pick<CreateFormResponseInput, 'formFields' | 'complete'>
export type UseCreateFormResponseMutationOptions = UseGqlMutationCallbacks<
  CreateFormResponseMutation,
  CreateFormResponseVariables,
  unknown
>

export type FormResponseConfig = {
  formName: FormNameEnum
  formVersion: number
  ownerId: number
  ownerType: FormResponseOwnerTypeEnum
}

export const useCreateFormResponse = (
  { formName, formVersion, ownerId, ownerType }: FormResponseConfig,
  mutationOptions?: UseCreateFormResponseMutationOptions
) => {
  const { mutateAsync: createFormResponse } = useCreateFormResponseMutation()

  const optionsWithNotification = useMutationNotifier({ onSuccess: false }, mutationOptions)
  return useMutation(
    ({ formFields, complete }) =>
      createFormResponse({
        input: {
          formFields,
          ownerId,
          ownerType,
          formName,
          formVersion,
          complete,
        },
      }),
    optionsWithNotification
  )
}

export type { CreateFormResponseMutation }
